import { SoMeLinkArrayElementType } from "@/sanity/types/someLinks";
import classNames from "classnames";
import Link from "next/link";
import styles from "./SoMeLink.module.css";

//#region [Props]
type SoMeLinkProps = {
    links?: SoMeLinkArrayElementType[] | null;
    text: string;
    className?: string;
};
//#endregion

//#region [Component]
export default function SoMeLink({ links, text, className }: SoMeLinkProps) {
    if ((links?.length ?? 0) === 0) {
        return null;
    }
    const validLinks = links!.filter(l => l.url && l.url.trim() !== "");
    if (validLinks.length === 0) {
        return null;
    }


    return <div className={classNames(styles.SoMeLinkContainer, className)}>
        <span>{text}:</span>  {validLinks.map(l => {
            return <Link key={l._key} href={l.url!} className={styles.SoMeLink}><SoMeIcon className={styles.SoMeIcon} link={l} /></Link>;
        })}
    </div>;
}
//#endregion

function SoMeIcon({ link, className }: { link: SoMeLinkArrayElementType; className?: string }) {
    switch (link._type) {
        case "someFb":
            // eslint-disable-next-line @next/next/no-img-element
            return <img className={className} src="/Facebook_logo_2023.svg" width={45} height={45} alt="Følg Bygdekinoen på Facebook" />;
        case "someIg":
            // eslint-disable-next-line @next/next/no-img-element
            return <img className={className} src="/Instagram_Glyph_Gradient_2.svg" width={45} height={45} alt="Følg Bygdekinoen på Instagram" />;
        default:
            return null;
    }
}

//#region [Styles]

//#endregion